import * as React from 'react';

import {Button} from '../button/button';
import {Card} from '../card/card';
import {Illustration} from '../illustrations/illustration';
import {Link} from '../link/link';

import styles from './error-state-small.module.css';

type Props = {
    message?: string | null | undefined;
    hasBorder?: boolean;
};

export function ErrorStateSmall(props: Props) {
    return (
        <Card
            hasBorder={Boolean(props.hasBorder)}
            hasShadow={Boolean(props.hasBorder)}
            fitHeight={true}
            fitContent={true}
        >
            <div className={styles['error-state-small']}>
                <Illustration src='plug-error-state' width='100%' height='100%' />
                <div>
                    <strong>{props.message ? props.message : 'Oh no, something went wrong'}</strong>
                    <div className={styles.subtitle}>
                        Please{' '}
                        <Button
                            size='small'
                            variant='text-primary'
                            onClick={() => {
                                location.reload();
                            }}
                        >
                            try again
                        </Button>{' '}
                        or{' '}
                        <Link
                            size='small'
                            href='https://www.nutshell.com/support'
                            variant='primary'
                        >
                            contact support
                        </Link>
                        .
                    </div>
                </div>
            </div>
        </Card>
    );
}
